import {Component, input} from '@angular/core';
import {Choice} from '@shared/form/choice/choice';
import {FieldBaseComponent} from '@shared/form/field-base.component';

@Component({
  selector: 'app-boolean-field-base',
  imports: [],
  template: ''
})
export class BooleanFieldBaseComponent extends FieldBaseComponent<boolean | null> {

  public readonly valueLabel = input<string | null>();
}
